// extracted by mini-css-extract-plugin
module.exports = {"sider__layout":"SiderMain_sider__layout__3M3p6"};